import { api } from "../../services";

const dashboard = {
  state: {
    first_load: true,
    kpis: {},

    infos_chart_opportunities: {},

    channel_id: null,

    department_id: null,
    name_department_selected: null,
    departments_available: [],

    operator_id: null,
    operator_selected: {
      id: null,
      user_id: null,
      user: {
        id: null,
        name: null,
        is_online: null,
        online: null,
        verified: null
      }
    },

    model_operator_selected: {
      id: null,
      user_id: null,
      user: {
        id: null,
        name: null,
        is_online: null,
        online: null,
        verified: null
      }
    },
    name_user_selected: null,
    operators_available: [],

    info: {
      offline: {},
      tickets: {},
      tm: {}
    },
    chart: {},
    chart_pie: {},
    goals: {},
    watch: {},
  },
  getters: {},
  mutations: {
    SET_DASHBOARD_INFOS(state, payload) {
      state.info = payload
    },
    SET_DASHBOARD_CHART(state, payload) {
      state.chart = payload
      state.watch = Math.random()
    },
    SET_DASHBOARD_CHART_PIE(state, payload) {
      state.chart_pie = payload
      state.watch = Math.random()
    },
    SET_DASHBOARD_GOALS(state, payload) {
      state.goals = payload
    },
  },
  actions: {
    getDashboardInfo(context, payload = {}) {
      api.get('/dashboard/info', {
        params: payload
      }).then(response => {
        context.commit("SET_DASHBOARD_INFOS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getDashboardChart(context, payload = {}) {
      api.get('/dashboard/chart/tickets/peak', {
        params: payload
      }).then(async response => {
        context.commit("SET_DASHBOARD_CHART", response.data);
        await context.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getDashboardChartPie(context, payload = {}) {
      api.get('/dashboard/chart/sources', {
        params: payload
      }).then(response => {
        context.commit("SET_DASHBOARD_CHART_PIE", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getDashboardGoals(context, payload = {}) {
      api.get('/dashboard/last/five/goals', {
        params: payload
      }).then(response => {
        context.commit("SET_DASHBOARD_GOALS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default dashboard;
